var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5435 1.63302C16.2146 -0.0417531 18.5854 -0.0417485 19.2565 1.63303L22.4775 9.67119C22.7543 10.362 23.3918 10.842 24.1322 10.9171L32.4669 11.7621C34.1683 11.9346 34.8824 14.0244 33.6425 15.2021L27.1515 21.3672C26.6495 21.844 26.4298 22.5464 26.5706 23.2242L28.4254 32.1518C28.7855 33.8848 26.8827 35.1969 25.3909 34.2444L18.4763 29.8293C17.82 29.4102 16.98 29.4102 16.3237 29.8293L9.40908 34.2444C7.91727 35.1969 6.01451 33.8848 6.37456 32.1518L8.22939 23.2242C8.37021 22.5464 8.1505 21.844 7.64854 21.3672L1.1575 15.2021C-0.0824392 14.0244 0.631728 11.9346 2.33309 11.7621L10.6678 10.9171C11.4082 10.842 12.0457 10.362 12.3225 9.67119L15.5435 1.63302Z",
    fill: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.24df16857c623dfb22fd0090387c13ab.svg";
export { ForwardRef as ReactComponent };